module.exports = __webpack_public_path__ + "static/media/tetero-button.bf4695d0.png";